import React from 'react'
import PieChartPanel from '../../../components/Charts/PieChartPanel'
import FilterPanel from '../components/FilterPanel'
import PieLegend from '../components/PieLegend'

const WinLoseReport = () => {
    return (
        <div className='p-2'>
            <div className='flex justify-between border-b border-b-gray-300 pb-2'>
                <h6 className="font-semibold">Win Lose Report</h6>
                <FilterPanel />
            </div>
            <div className='flex flex-col items-center'>
                <div className="w-[70%] h-[200px]">
                    <PieChartPanel _data = {data}/>
                </div>
                <PieLegend _data = {data}/>
            </div>
        </div>
    )
}

export default WinLoseReport;

const data = [
    {
        "name" : "Betting",
        "value" : 500000
    },
    {
        "name" : "Win",
        "value" : 300000
    }
]